import React, { Fragment } from 'react'
import SbEditable from 'storyblok-react'
import ArticleStackedTeaser from 'gatsby-theme-kn/src/components/atoms/ArticleStackedTeaser'
import Headline from 'gatsby-theme-kn/src/components/atoms/Headline'
import Slider from 'react-slick'
import { useStaticQuery, graphql } from 'gatsby'

const ArticleTeaserBlock = ({ block, className, data_limit, data_source }) => {
  // de live: parent_id: 184923977, 184923986
  // en live: parent_id: 184924556, 184924560
  // fr live: parent_id: 184924971, 184924974
  // nl live: parent_id: 184925386, 184925390

  const data = useStaticQuery(graphql`
    query NewArticlesQuery {
      de: allStoryblokEntry(
        limit: 8
        filter: { parent_id: { eq: 184923977 } }
        sort: { fields: field_date_string, order: DESC }
      ) {
        edges {
          node {
            name
            full_slug
            field_category_string
            content
          }
        }
      }
      en: allStoryblokEntry(
        limit: 8
        filter: { parent_id: { eq: 184924556 } }
        sort: { fields: field_date_string, order: DESC }
      ) {
        edges {
          node {
            name
            full_slug
            field_category_string
            content
          }
        }
      }
      fr: allStoryblokEntry(
        limit: 8
        filter: { parent_id: { eq: 184924971 } }
        sort: { fields: field_date_string, order: DESC }
      ) {
        edges {
          node {
            name
            full_slug
            field_category_string
            content
          }
        }
      }
      nl: allStoryblokEntry(
        limit: 8
        filter: { parent_id: { eq: 184925386 } }
        sort: { fields: field_date_string, order: DESC }
      ) {
        edges {
          node {
            name
            full_slug
            field_category_string
            content
          }
        }
      }
    }
  `)

  let lang

  if (typeof window !== 'undefined') {
    lang = window.location.pathname.split('/')[1]
  }

  let articles = data[lang]?.edges

  const settings = {
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    mobileFirst: true,
    infinite: false,
    appendDots: (dots) => <ul> {dots} </ul>,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick',
      },
      {
        breakpoint: 1140,
        settings: {
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  if (!data_source) {
    return (
      <SbEditable content={block}>
        <section
          className={`article-teaser-block ${className} ${
            block.space_top ? block.space_top : ''
          } ${block.space_bottom ? block.space_bottom : ''}`}
        >
          <div className="article-teaser-block-container">
            <div
              className="article-teaser-block-wrapper"
              data-rellax-center={true}
              data-rellax-speed={-1}
            >
              <Headline
                kicker={block.kicker}
                headline={block.headline}
                subheadline={block.subheadline}
              />
              <Slider
                className="article-teaser-block-row justify-content-start"
                {...settings}
              >
                {data_limit && data_limit.length > 0
                  ? articles &&
                    articles?.map((item, index) => (
                      <Fragment key={index}>
                        {index < data_limit && (
                          <ArticleStackedTeaser item={item} />
                        )}
                      </Fragment>
                    ))
                  : articles &&
                    articles?.map((item, index) => (
                      <ArticleStackedTeaser item={item} key={index} />
                    ))}
              </Slider>
            </div>
          </div>
        </section>
      </SbEditable>
    )
  }

  if (data_source) {
    return (
      <SbEditable content={block}>
        <section
          className={`article-teaser-block ${className} ${
            block.space_top ? block.space_top : ''
          } ${block.space_bottom ? block.space_bottom : ''}`}
        >
          <div className="article-teaser-block-container">
            <div
              className="article-teaser-block-wrapper"
              data-rellax-center={true}
              data-rellax-speed={-1}
            >
              <Headline
                kicker={block.kicker}
                headline={block.headline}
                subheadline={block.subheadline}
              />
              <Slider
                className="article-teaser-block-row justify-content-start"
                {...settings}
              >
                {data_limit && data_limit.length > 0
                  ? data_source &&
                    data_source?.map((item, index) => (
                      <>
                        {index < data_limit && (
                          <ArticleStackedTeaser item={item} key={index} />
                        )}
                      </>
                    ))
                  : data_source &&
                    data_source?.map((item, index) => (
                      <ArticleStackedTeaser item={item} key={index} />
                    ))}
              </Slider>
            </div>
          </div>
        </section>
      </SbEditable>
    )
  }
}

export default ArticleTeaserBlock
